// @owners { team: patients-team }
import { getDefaultAddress } from '~shared/features/checkout/selectors/getDefaultAddress';
import { getOrderAddressId } from '~shared/features/checkout/selectors/getOrder';
import { useSelectorShared } from '~shared/store';

export const useNextAvailableDateAddressId = () => {
  const orderAddressId = useSelectorShared(getOrderAddressId);
  const defaultAddress = useSelectorShared(getDefaultAddress);
  return orderAddressId || defaultAddress?.id;
};
